import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupOddsByName',
})
export class GroupOddsByName implements PipeTransform {
  transform(value, args: string[]): any {
    const groups = {};
    if (value != null)
      if (value.length > 0) {
        value.forEach(function (o) {
          const seqNum = o.SeqNumber;
          const groupName = o.GroupName;
          const outcomesDescription = o.OutcomesDescription;
          const OddTypeId = o.OddTypeId;
          groups[groupName] = groups[groupName]
            ? groups[groupName]
            : { OddTypeId: OddTypeId, GroupName: groupName, OutcomesDescription: outcomesDescription, seq: seqNum, eOdds: [] };
          groups[groupName].eOdds.push(o);
        });
      }
    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }
}
